/**
 * Plug-and-play settings pages: drop a .ts (default-exporting a SettingsPage)
 * or a plain .json file matching the same shape into ./pages, and it shows
 * up in the Settings dialog's left nav automatically — nothing else to wire
 * up. require.context is webpack's static-analysis hook for "require every
 * file matching this glob", which is what makes that discovery possible
 * without a hand-maintained import list.
 */

import type { SettingsPage } from "./types";

const context = require.context("./pages", false, /\.(ts|json)$/);

function isSettingsPage(value: unknown): value is SettingsPage {
  const page = value as SettingsPage | null;
  return (
    !!page &&
    typeof page === "object" &&
    typeof page.id === "string" &&
    typeof page.label === "string" &&
    Array.isArray(page.items)
  );
}

function loadPages(): SettingsPage[] {
  const pages: SettingsPage[] = [];
  for (const key of context.keys()) {
    const mod = context<{ default?: SettingsPage }>(key);
    const page = mod && typeof mod === "object" && "default" in mod ? mod.default : mod;
    if (isSettingsPage(page)) {
      pages.push(page);
    } else {
      console.warn(`[settings] Skipping ${key}: does not export a valid SettingsPage`);
    }
  }
  return pages.sort((a, b) => (a.order ?? 0) - (b.order ?? 0) || a.label.localeCompare(b.label));
}

export const settingsPages: SettingsPage[] = loadPages();
